import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Image from 'next/image';
import { Box } from '@chakra-ui/react';
const imageBase = {
    position: 'relative',
    width: '100%',
    minHeight: '400px',
    overflow: 'hidden',
};
export const BannerImage = ({ imageDesktop, imageMobile, imageBox, overlayBackground, root, }) => {
    if (!imageDesktop?.src && !imageMobile?.src) {
        return null;
    }
    return (_jsxs(Box, { display: "flex", alignItems: "stretch", ...root, children: [_jsxs(Box, { display: ['none', 'none', 'block'], ...imageBase, ...imageBox, children: [_jsx(Image, { src: imageDesktop?.src || imageMobile?.src || '', alt: imageDesktop?.alt || imageMobile?.alt || '', layout: "fill", objectFit: "cover" }), overlayBackground && (_jsx(Box, { position: "absolute", top: "0", left: "0", width: "100%", height: "100%", background: overlayBackground }))] }), _jsxs(Box, { display: ['block', 'block', 'none'], ...imageBase, ...imageBox, children: [_jsx(Image, { src: imageMobile?.src || imageDesktop?.src || '', alt: imageMobile?.alt || imageDesktop?.alt || '', layout: "fill", objectFit: "cover" }), overlayBackground && (_jsx(Box, { position: "absolute", top: "0", left: "0", width: "100%", height: "100%", background: overlayBackground }))] })] }));
};
